<template>
  <popup v-model="visible" size="sm">
    <contact-travel-expert
      :expert-data="expertData"
      :tour-name="tourName"
      :trip-id="tripId"
      @done="visible = false"
    />
  </popup>
</template>

<script>
import Popup from "@/components/ui-kit/popup/index.vue";
import ContactTravelExpert from "@/components/organisms/contact-travel-expert/index.vue";

export default {
  components: {
    Popup,
    ContactTravelExpert,
  },
  model: {
    prop: "modelValue",
    event: "change",
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    expertData: {
      type: Object,
      required: true,
    },
    tourName: {
      type: String,
      default: "",
    },
    tripId: {
      type: [String, Number],
      required: true,
    },
  },
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("change", value);
      },
    },
  },
};
</script>
